/**
 * Created by 叶子 on 2017/8/13.
 */
import React, { Component } from 'react';
// import { Router, Route, hashHistory, IndexRedirect } from 'react-router';
import { Route, Redirect, Switch } from 'react-router-dom';
import Gywm from "../components/gywm";
import Cgal from "../components/cgal";
import Xwzx from "../components/xwzx";
import Yjjy from "../components/yjjy";
import Zpxx from "../components/zpxx";
import Lxwm from "../components/lxwm";



export default class CRouter extends Component {
    requireAuth = (permission, component) => {
        const { auth } = this.props;
        const { permissions } = auth.data;
        // const { auth } = store.getState().httpData;
        if (!permissions || !permissions.includes(permission)) return <Redirect to={'404'} />;
        return component;
    };
    render() {
        return (
            <Switch>
                <Route path="/feima/gywm" component={Gywm} />
                <Route path="/feima/cgal" component={Cgal} />
                <Route path="/feima/xwzx" component={Xwzx} />
                <Route path="/feima/yjjy" component={Yjjy} />
                <Route path="/feima/zpxx" component={Zpxx} />
                <Route path="/feima/jrwm" component={Zpxx} />
                <Route path="/feima/lxwm" component={Lxwm} />
            </Switch>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/index.js